import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiResponse } from './models/api-response';

import { ServicerProvider } from './servicer';
import { DashboardServletLogsApiParameter } from './models/dashboard-servlet-logs-api-parameter';
import { CollectionInfoApiResponse } from './models/collection-info-api-response';


/**
 * シミュレート のプロバイダー.
 */
 @Injectable()
 export class MongoCollectionServiceProvider { 
   constructor(
     private servicer: ServicerProvider
   ) { }
 
  /**
   * コレクションの情報をリクエスト.
   * 
   * @returns Observable<StationListApiResponse>
   */
  postCllectionInfoRequest(): Observable<CollectionInfoApiResponse>{
    console.log("call")
    return this.servicer.postApi('/PostCollectionInfo', null);
  }

    /**
   * コレクション新規追加のリクエスト.
   * 
   * @param parameter OverwriteDashboardServletLogsApiParameter
   * @returns Observable<ApiResponse>
   */
  postOverwriteDashboardServletLogsRequest(parameter: DashboardServletLogsApiParameter): Observable<ApiResponse>{
    console.log('postOverwriteDashboardServletLogsRequest実行');
    return this.servicer.postApi<string, ApiResponse>(
      '/overwrite_DashboardServletLogs',
      this.servicer.parameterToBody(parameter));
  }

  /**
   * コレクション変更のリクエスト.
   * 
   * @param parameter SelectCollectionApiParameter
   * @returns Observable<ApiResponse>
   */
  postSelectCollectionRequest(parameter: DashboardServletLogsApiParameter): Observable<ApiResponse>{
    return this.servicer.postApi<string, ApiResponse>(
      '/select_global_collection_name',
      this.servicer.parameterToBody(parameter));
  }

  /**
   * コレクション削除のリクエスト.
   * 
   * @param parameter DropDashboardServletLogsApiParameter
   * @returns Observable<ApiResponse>
   */
   postDropDashboardServletLogsRequest(parameter: DashboardServletLogsApiParameter): Observable<ApiResponse>{
    return this.servicer.postApi<string, ApiResponse>(
      '/drop_DashboardServletLogs',
      this.servicer.parameterToBody(parameter));
  }
 }
 


// WEBPACK FOOTER //
// ./src/providers/servicer/mongo-collection-service.ts